import axios from 'axios';
import Cookies from 'cookies-js';

let baseAxiosURL;

if (process.env.NODE_ENV === 'development') {
  baseAxiosURL = API_URL; //eslint-disable-line
} else {
  baseAxiosURL = '/api/';
}
const client = axios.create({
  baseURL: baseAxiosURL,
  timeout: 30000,
});
const csrftoken = Cookies.get('csrftoken');
axios.defaults.headers.common['X-CSRFToken'] = csrftoken;
axios.defaults.headers.patch['Content-Type'] = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/json';

if (process.env.NODE_ENV !== 'production') {
  const developCookie = 'f^msnddsfnblj6-4ne8_^==h9)^p^v@#ut7uvx$pdqo&*a1re9';
  axios.defaults.headers.common['X-AID'] = developCookie;
}

export default client;



// WEBPACK FOOTER //
// ./src/services/http.js